import { Component, HostListener, AfterViewInit, effect, OnInit, ViewChild } from '@angular/core';
import { Router, NavigationEnd, NavigationStart } from '@angular/router';
import { AppSettings } from '../../shared/app-settings';
import { LoginService } from '../../components/login/login.service';
import { MsalService } from '@azure/msal-angular';

import { ToastService } from '../../services/toast-service';
import { HomeService } from '../home/home.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { BugReportButtonComponent } from '../bug-report/bug-report-button/bug-report-button.component';
import { trigger, state, style, transition, animate } from '@angular/animations';

@HostListener('window:resize', ['$event'])
@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrls: ['./menu.component.scss'],
    animations: [
        trigger('slideDown', [
            transition(':enter', [
                style({ height: '0', opacity: '0', overflow: 'hidden' }),
                animate('200ms ease-out', style({ height: '*', opacity: '1' }))
            ]),
            transition(':leave', [
                style({ height: '*', opacity: '1', overflow: 'hidden' }),
                animate('200ms ease-in', style({ height: '0', opacity: '0' }))
            ])
        ])
    ]
})
export class MenuComponent implements AfterViewInit {
    @ViewChild(BugReportButtonComponent) bugReportButton?: BugReportButtonComponent;

    menu: any = [];
    messageCount;
    domaninDetails: any = {};
    currentMenu: any = {};
    breadcrumbs: any = [];
    expanded = false;
    window = window;
    menuWidth = { largeMenu: '265px', smallMenu: '65px' };
    user = null;
    loggedIn = this.loginService.isLoggedIn();
    menuCollapse = false;
    isFixedAssetMenu = false;
    fixedAssetMenu: any = [];
    environment = environment;
    defaultAppLogo: string = '/assets/customers/default/konti-small.png';
    defaultAppCustomerLogo: string = '/assets/customers/default/logo.png';

    // Mobile submenu expansion state
    expandedMobileMenus: Set<string> = new Set();
    mobileMenuOpen = false;
    mobileMenuSearchTerm = '';
    displayedMenu: any[] = [];
    displayedFixedAssetMenu: any[] = [];
    recentMenuItems: any[] = [];
    private readonly maxRecentMenuItems = 8;
    private readonly recentMenuSectionName = '__recent__';
    private readonly settingsMenuSectionName = '__settings__';

    // Chromeless routes — render only <router-outlet> without sidebar/topbar
    isChromelessRoute = false;
    isExternalUser = false;

    constructor(
        private router: Router,
        private loginService: LoginService,
        private translateService: TranslateService,
        private homeService: HomeService,
        private msalService: MsalService,
        private toastService: ToastService
    ) {
        router.events.subscribe((event) => {
            if (event instanceof NavigationStart) {
                // Reset mobile submenu expansion on navigation
                this.expandedMobileMenus.clear();

                const storedUser = JSON.parse(localStorage.getItem(AppSettings.StorageKeys.User) || '{}');
                this.isExternalUser = !!storedUser?.isExternalUser;

                // Keep full app chrome for external users, but stay chromeless on dedicated public routes.
                this.isChromelessRoute = event.url.startsWith('/chemical/') || event.url.startsWith('/auth/switch');

                if (event.url.startsWith('/fixed-asset/'))
                    localStorage.setItem(
                        AppSettings.StorageKeys.IsFixedAssetMenu,
                        'true'
                    );
                else
                    localStorage.setItem(
                        AppSettings.StorageKeys.IsFixedAssetMenu,
                        'false'
                    );
            }
        });
        effect(() => {
            this.loggedIn = this.loginService.isLoggedIn();
            if (this.loggedIn) {
                toastService;
                var details = JSON.parse(
                    localStorage.getItem(AppSettings.StorageKeys.DomainDetails)
                );
                this.user = JSON.parse(
                    localStorage.getItem(AppSettings.StorageKeys.User)
                );
                this.isExternalUser = !!this.user?.isExternalUser;
                this.isChromelessRoute = this.router.url.startsWith('/chemical/') || this.router.url.startsWith('/auth/switch');
                this.messageCount = localStorage.getItem(
                    AppSettings.StorageKeys.MessageCount
                );
                this.menu = JSON.parse(
                    localStorage.getItem(AppSettings.StorageKeys.Menu)
                );
                this.mobileMenuSearchTerm = localStorage.getItem(AppSettings.StorageKeys.MobileMenuSearch) || '';
                this.loadRecentMenuItems();
                this.domaninDetails = details != null ? details : {};

                // Check if user has access to Fixed Asset menu from backend (already filtered by rights)
                const hasFixedAssetAccess = this.menu ?.some(m =>
                    m.angularPageLink ?.startsWith('/fixed-asset') ||
                        m.name ?.trim().toUpperCase() === 'ANLEGGSREGISTER'
                );

                // Always create Fixed Asset submenu if user has access (regardless of isFixedAssetMenu flag)
                if (hasFixedAssetAccess) {
                    var menu = localStorage.getItem(
                        AppSettings.StorageKeys.FixedAssetMenu
                    );
                    if (menu == null) {
                        this.createFixedassetMenu();
                        localStorage.setItem(
                            AppSettings.StorageKeys.FixedAssetMenu,
                            JSON.stringify(this.fixedAssetMenu)
                        );
                    } else this.fixedAssetMenu = JSON.parse(menu);
                }

                this.isFixedAssetMenu = Boolean(
                    JSON.parse(
                        localStorage.getItem(AppSettings.StorageKeys.IsFixedAssetMenu)
                    )
                );

                // If trying to view Fixed Asset menu but no access, redirect
                if (this.isFixedAssetMenu && !hasFixedAssetAccess) {
                    this.isFixedAssetMenu = false;
                    localStorage.setItem(AppSettings.StorageKeys.IsFixedAssetMenu, 'false');
                    this.router.navigateByUrl('/home');
                }
                setTimeout(() => {
                    this.applyMobileMenuFilters();
                    this.getCurrentMenu(
                        this.router.url,
                        this.router.routerState.snapshot.root.params
                    );
                    this.getBreadcrumbs();
                }, 0);
                if (this.router.url == '/login') {
                    this.expanded = false;
                    setTimeout(() => {
                        this.toggleMenu();
                    }, 0);
                }
            }
        });
    }

    createFixedassetMenu() {
        this.fixedAssetMenu = [];
        var item = {
            name: this.translateService.instant('Menu.dashboard'),
            angularPageLink: '/fixed-asset/dashboard',
            angularIcon: '/assets/tablerIcons/outline/dashboard.svg',
            subMenu: [],
        };
        this.fixedAssetMenu.push(item);
        item = {
            name: this.translateService.instant('Menu.fixedAsset'),
            angularPageLink: '/fixed-asset/display-fixed-asset',
            angularIcon: '/assets/tablerIcons/outline/blocks.svg',
            subMenu: [
                {
                    name: this.translateService.instant('Menu.fixedAssetOverview'),
                    angularPageLink: '/fixed-asset/display-fixed-asset',
                    angularIcon: '/assets/tablerIcons/outline/dashboard.svg',
                    isVisibleInMenu: true,
                },
                {
                    name: this.translateService.instant('Menu.projectOverView'),
                    angularPageLink: '/fixed-asset/display-project',
                    angularIcon: '/assets/tablerIcons/outline/dashboard.svg',
                    isVisibleInMenu: true,
                },
                {
                    name: this.translateService.instant('Menu.nisDisposal'),
                    angularPageLink: '/fixed-asset/nis-disposal',
                    angularIcon: '/assets/tablerIcons/outline/dashboard.svg',
                    isVisibleInMenu: true,
                }
            ],
        };
        this.fixedAssetMenu.push(item);
        item = {
            name: this.translateService.instant('Menu.vismaLog'),
            angularPageLink: '/fixed-asset/visma/visma-change-log',
            angularIcon: '/assets/tablerIcons/outline/transfer.svg',
            subMenu: [
                {
                    name: this.translateService.instant('Menu.incomingTransactions'),
                    angularPageLink: '/fixed-asset/visma/visma-change-log',
                    angularIcon: '/assets/tablerIcons/outline/dashboard.svg',
                    isVisibleInMenu: true,
                },
                {
                    name: this.translateService.instant('Menu.outgoingTransactions'),
                    angularPageLink: '/fixed-asset/visma/outgoing-transaction',
                    angularIcon: '/assets/tablerIcons/outline/dashboard.svg',
                    isVisibleInMenu: true,
                }
            ]
        };
        this.fixedAssetMenu.push(item);
        item = {
            name: this.translateService.instant('Menu.controlPanel'),
            angularPageLink: '/fixed-asset/control-panel',
            angularIcon: '/assets/tablerIcons/outline/settings.svg',
            subMenu: [],
        };
        this.fixedAssetMenu.push(item);
        this.applyMobileMenuFilters();
    }

    ngAfterViewInit() {
        setTimeout(() => {
            if (this.loggedIn) this.toggleMenu();
            this.toggleMenu(); //hide menu
        }, 0);

        window.addEventListener('storage', (event: StorageEvent) => {
            if (event.key === AppSettings.StorageKeys.Menu && event.newValue) {
                this.menu = JSON.parse(event.newValue);
            }
        });
    }

    onResize(event: any) {
        if (this.loggedIn) this.setContainerWidth(event.target.innerWidth, true);
    }

    setIcon() {
        this.menuCollapse = !this.menuCollapse;
        if (window.innerWidth <= 767) {
            this.mobileMenuOpen = !this.mobileMenuOpen;
        }
    }

    setContainerWidth(width, expanded) {
        var element = document.getElementById('sidebar-nav');
        if (width <= 767) {
            var menu = document.getElementById('menu');
            menu.classList.remove('show');
            this.mobileMenuOpen = false;
            this.expanded = expanded;
            element.style.width = this.menuWidth.largeMenu;
        } else {
            var content = document.getElementsByClassName(
                'content'
            ) as HTMLCollectionOf<HTMLElement>;
            content[0].style.width = 'calc(100% - ' + element.style.width + ')';
        }
    }

    logOut(event?: MouseEvent) {
        if (event) event.preventDefault();
        localStorage.removeItem(AppSettings.StorageKeys.Token);
        localStorage.removeItem(AppSettings.StorageKeys.User);
        localStorage.removeItem(AppSettings.StorageKeys.ClientConfig);
        localStorage.removeItem(AppSettings.StorageKeys.TimeConfig);
        localStorage.removeItem(AppSettings.StorageKeys.DomainDetails);
        localStorage.removeItem(AppSettings.StorageKeys.MessageCount);
        localStorage.removeItem(AppSettings.StorageKeys.Menu);
        localStorage.removeItem(AppSettings.StorageKeys.FinalApproval);
        localStorage.removeItem(AppSettings.StorageKeys.IsFixedAssetMenu);
        localStorage.removeItem(AppSettings.StorageKeys.FixedAssetMenu);
        localStorage.removeItem(AppSettings.StorageKeys.MobileRecentMenu);
        localStorage.removeItem(AppSettings.StorageKeys.MobileMenuSearch);
        this.homeService.dashboardData.set(null);
        this.loginService.isLoggedIn.set(false);
        if (this.msalService.instance.getAllAccounts().length > 0)
            this.msalService.logout();
        else this.router.navigate(['/login']);
    }

    getCurrentMenu(angularPageLink, params) {
        var menu = this.menu;
        if (this.isFixedAssetMenu) {
            menu = this.fixedAssetMenu;
        }
        if (angularPageLink != null) {
            var originalLink = angularPageLink;
            var url = angularPageLink.trim().split('/');

            // For URLs like /settings/portal-setting/scheduled-notifications
            // We need to try /settings/portal-setting first, not just /settings
            if (url.length > 2) {
                if (url.length >= 4) {
                    // Try the middle level first: /settings/portal-setting
                    angularPageLink = '/' + url[1] + '/' + url[2] + '/' + url[3];
                } else {
                    angularPageLink = '/' + url[1] + '/' + url[2];
                }
            }

            url = angularPageLink.trim().split('?');
            if (url.length == 2) angularPageLink = url[0];

            var currentMenu = menu.filter((item) => {
                return item.angularPageLink == angularPageLink;
            });
            if (currentMenu.length == 0) {
                currentMenu = menu.filter((item) => {
                    var subMenu = item.subMenu.filter((element) => {
                        if (
                            element.angularPageLink == angularPageLink &&
                            element.isVisibleInMenu == true
                        )
                            return element;
                    });
                    item.filteredElement = subMenu;
                    return subMenu.length > 0;
                });
                if (currentMenu.length > 0) {
                    this.setBreadcrumbsData(
                        currentMenu[0].angularPageLink,
                        currentMenu[0].name,
                        params
                    );
                    if (currentMenu[0].filteredElement[0].isVisibleInMenu) {
                        this.setBreadcrumbsData(
                            currentMenu[0].filteredElement[0].angularPageLink,
                            currentMenu[0].filteredElement[0].name,
                            params
                        );

                        // Check for sub-sub-menu (3rd level) for URLs like /settings/portal-setting/scheduled-notifications
                        if (originalLink !== currentMenu[0].filteredElement[0].angularPageLink &&
                            currentMenu[0].filteredElement[0].subMenu &&
                            currentMenu[0].filteredElement[0].subMenu.length > 0) {
                            var subSubMenu = currentMenu[0].filteredElement[0].subMenu.filter((element) => {
                                return element.angularPageLink == originalLink && element.isVisibleInMenu == true;
                            });
                            if (subSubMenu.length > 0) {
                                this.setBreadcrumbsData(
                                    subSubMenu[0].angularPageLink,
                                    subSubMenu[0].name,
                                    params
                                );
                            }
                        }
                    }
                }
            } else {
                this.setBreadcrumbsData(angularPageLink, currentMenu[0].name, params);
                var subMenu = currentMenu[0].subMenu.filter((element) => {
                    if (element.angularPageLink == angularPageLink) return element;
                });
                if (subMenu.length > 0 && subMenu[0].isVisibleInMenu)
                    this.setBreadcrumbsData(
                        subMenu[0].angularPageLink,
                        subMenu[0].name,
                        params
                    );
            }

            // Search menu3 items (subMenu of subMenu) if still no match
            if (!currentMenu || currentMenu.length == 0) {
                let menu3Found = false;
                for (const menu1Item of menu) {
                    if (menu3Found) break;
                    for (const menu2Item of (menu1Item.subMenu || [])) {
                        const menu3Match = (menu2Item.subMenu || []).find(
                            (m3: any) => m3.angularPageLink === angularPageLink
                        );
                        if (menu3Match) {
                            currentMenu = [menu1Item];
                            this.setBreadcrumbsData(menu1Item.angularPageLink, menu1Item.name, params);
                            this.setBreadcrumbsData(menu2Item.angularPageLink, menu2Item.name, params);
                            this.setBreadcrumbsData(menu3Match.angularPageLink, menu3Match.name, params);
                            menu3Found = true;
                            break;
                        }
                    }
                }
            }

            // Fallback: if no match found, progressively strip URL segments
            // to find the parent menu item (e.g., /work-order/detail/7427 → /work-order)
            if (!currentMenu || currentMenu.length == 0) {
                var segments = angularPageLink.split('/').filter(s => s);
                while (segments.length > 1 && (!currentMenu || currentMenu.length == 0)) {
                    segments.pop();
                    var shorterLink = '/' + segments.join('/');

                    currentMenu = menu.filter((item) => item.angularPageLink == shorterLink);

                    if (currentMenu.length == 0) {
                        currentMenu = menu.filter((item) => {
                            var subMenu = item.subMenu.filter((element) => {
                                if (element.angularPageLink == shorterLink && element.isVisibleInMenu == true)
                                    return element;
                            });
                            item.filteredElement = subMenu;
                            return subMenu.length > 0;
                        });
                    }

                    // Prefix match: find menu1 item whose angularPageLink starts with this segment
                    // (e.g. /bank-reconciliation/dashboard matches when shorterLink is /bank-reconciliation)
                    if (currentMenu.length == 0) {
                        currentMenu = menu.filter((item) =>
                            item.angularPageLink && item.angularPageLink.startsWith(shorterLink + '/')
                        );
                        if (currentMenu.length > 0) {
                            currentMenu[0].filteredElement = [];
                        }
                    }
                }

                if (currentMenu && currentMenu.length > 0) {
                    this.setBreadcrumbsData(
                        currentMenu[0].angularPageLink,
                        currentMenu[0].name,
                        params
                    );
                    // If matched via subMenu, add submenu breadcrumb too
                    if (currentMenu[0].filteredElement && currentMenu[0].filteredElement.length > 0
                        && currentMenu[0].filteredElement[0].isVisibleInMenu) {
                        this.setBreadcrumbsData(
                            currentMenu[0].filteredElement[0].angularPageLink,
                            currentMenu[0].filteredElement[0].name,
                            params
                        );
                    }
                }
            }

            this.currentMenu = currentMenu[0];
        }
    }

    setBreadcrumbsData(url, label, params) {
        this.breadcrumbs.push({
            url: url,
            label: label,
            params: params,
        });
    }

    getBreadcrumbs() {
        this.router.events.subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.breadcrumbs = [];
                if (this.menu.length > 0) {
                    let snapshot = this.router.routerState.snapshot;
                    this.getCurrentMenu(event.url, snapshot.root.params);
                }
            }
        });
    }

    toggleMenu() {
        const content = document.getElementsByClassName('content') as HTMLCollectionOf<HTMLElement>;
        const element = document.getElementById('sidebar-nav');
        const isMobile = window.innerWidth <= 767;
        if (element) {
            if (isMobile) {
                element.style.width = this.menuWidth.largeMenu;
                const menuEl = document.getElementById('menu');
                if (menuEl) menuEl.classList.remove('show');
            } else {
                if (element.style.width == this.menuWidth.largeMenu) {
                    element.style.width = this.menuWidth.smallMenu;
                    if (content[0]) content[0].style.width = 'calc(100% - ' + this.menuWidth.smallMenu + ')';
                } else {
                    element.style.width = this.menuWidth.largeMenu;
                    if (content[0]) content[0].style.width = 'calc(100% - ' + this.menuWidth.largeMenu + ')';
                }
            }
        }
        if (isMobile) {
            // Keep labels visible on mobile; avoid d-none when the menu is open
            this.expanded = true;
            return;
        }
        // Desktop: toggle label collapse/expand with a small delay for animation
        if (this.expanded) this.expanded = !this.expanded;
        else
            setTimeout(() => {
                this.expanded = !this.expanded;
            }, 150);
    }

    navigateByUrl(url, event?: MouseEvent) {
        if (event && (event.ctrlKey || event.metaKey)) {
            // Ctrl+klikk eller Cmd+klikk: åpne i ny fane
            event.preventDefault();
            window.open(url, '_blank');
            return;
        }

        if (url == '/fixed-asset/dashboard') {
            this.setFixedAssetMenu(true);
        }
        if (url) {
            this.router.navigateByUrl(url);
            this.scrollIntoView();
            // Close mobile menu after navigation
            this.closeMobileMenu();
        }
    }

    closeMobileMenu() {
        // Only on mobile screens
        if (window.innerWidth <= 767) {
            const menuElement = document.getElementById('menu');
            if (menuElement) {
                // Remove 'show' class to close Bootstrap collapse
                menuElement.classList.remove('show');
            }
            // Also clear expanded submenus
            this.expandedMobileMenus.clear();
            this.mobileMenuOpen = false;
        }
    }

    onMobileSearchInput(event: Event) {
        const value = (event.target as HTMLInputElement)?.value || '';
        this.mobileMenuSearchTerm = value;
        localStorage.setItem(AppSettings.StorageKeys.MobileMenuSearch, this.mobileMenuSearchTerm);
        this.applyMobileMenuFilters();
    }

    clearMobileSearch() {
        this.mobileMenuSearchTerm = '';
        localStorage.setItem(AppSettings.StorageKeys.MobileMenuSearch, this.mobileMenuSearchTerm);
        this.applyMobileMenuFilters();
    }

    private applyMobileMenuFilters() {
        this.displayedMenu = this.filterMenuBySearch(this.menu || [], this.mobileMenuSearchTerm);
        this.displayedFixedAssetMenu = this.filterMenuBySearch(this.fixedAssetMenu || [], this.mobileMenuSearchTerm);
    }

    private filterMenuBySearch(menuItems: any[], searchTerm: string): any[] {
        if (!searchTerm || !searchTerm.trim()) {
            return menuItems;
        }

        const query = searchTerm.trim().toLowerCase();

        return menuItems
            .map((item) => {
                const topMatch = (item.name || '').toLowerCase().includes(query);
                const subMenu = (item.subMenu || [])
                    .map((sub) => {
                        const subMatch = (sub.name || '').toLowerCase().includes(query);
                        const subSubMenu = (sub.subMenu || []).filter((subChild) =>
                            (subChild.name || '').toLowerCase().includes(query)
                        );

                        if (subMatch || subSubMenu.length > 0 || topMatch) {
                            return {
                                ...sub,
                                subMenu: subSubMenu.length > 0 || !subMatch ? subSubMenu : sub.subMenu,
                            };
                        }

                        return null;
                    })
                    .filter((sub) => sub !== null);

                if (topMatch || subMenu.length > 0) {
                    return {
                        ...item,
                        subMenu,
                    };
                }

                return null;
            })
            .filter((item) => item !== null);
    }

    private loadRecentMenuItems() {
        try {
            const stored = localStorage.getItem(AppSettings.StorageKeys.MobileRecentMenu);
            this.recentMenuItems = stored ? JSON.parse(stored) : [];
        } catch {
            this.recentMenuItems = [];
        }
    }

    private addRecentMenuItem(item: any, parentItem?: any) {
        if (!item?.angularPageLink || item.angularPageLink.startsWith('http')) {
            return;
        }

        const entry = {
            name: item.name,
            angularPageLink: item.angularPageLink,
            angularIcon: item.angularIcon || '/assets/tablerIcons/outline/apps.svg',
            parentName: parentItem?.name || null,
            parentIcon: parentItem?.angularIcon || null,
        };

        this.recentMenuItems = [
            entry,
            ...this.recentMenuItems.filter((recent) => recent.angularPageLink !== entry.angularPageLink),
        ].slice(0, this.maxRecentMenuItems);

        localStorage.setItem(
            AppSettings.StorageKeys.MobileRecentMenu,
            JSON.stringify(this.recentMenuItems)
        );
    }

    navigateRecentItem(item: any, event?: MouseEvent) {
        if (event) {
            event.preventDefault();
        }

        if (item?.angularPageLink) {
            if (item.angularPageLink === '/fixed-asset/dashboard' || item.angularPageLink.startsWith('/fixed-asset/')) {
                this.setFixedAssetMenu(true);
            } else {
                this.setFixedAssetMenu(false);
            }

            this.router.navigateByUrl(item.angularPageLink).then(() => {
                this.addRecentMenuItem(item, item.parentName ? { name: item.parentName, angularIcon: item.parentIcon } : null);
                this.closeMobileMenu();
            });
        }
    }

    private scrollMenuItemIntoView(menuItemElement?: HTMLElement) {
        if (!menuItemElement) {
            return;
        }

        const sidebar = document.getElementById('sidebar-nav');
        if (!sidebar) {
            return;
        }

        const sidebarRect = sidebar.getBoundingClientRect();
        const itemRect = menuItemElement.getBoundingClientRect();
        const topOffset = 12;
        const targetScrollTop = sidebar.scrollTop + (itemRect.top - sidebarRect.top) - topOffset;

        sidebar.scrollTo({
            top: Math.max(0, targetScrollTop),
            behavior: 'smooth',
        });
    }

    toggleMobileSubmenu(menuName: string) {
        if (this.expandedMobileMenus.has(menuName)) {
            this.expandedMobileMenus.delete(menuName);
        } else {
            // Accordion: lukk andre menyer på samme nivå, behold menu3-nøkler (inneholder '__')
            const keysToRemove = [...this.expandedMobileMenus].filter(k => !k.includes('__'));
            keysToRemove.forEach(k => this.expandedMobileMenus.delete(k));
            this.expandedMobileMenus.add(menuName);
        }
    }

    toggleMenu3Submenu(key: string) {
        if (this.expandedMobileMenus.has(key)) {
            this.expandedMobileMenus.delete(key);
        } else {
            this.expandedMobileMenus.add(key);
        }
    }

    toggleRecentMenu() {
        this.toggleMobileSubmenu(this.recentMenuSectionName);
    }

    isRecentMenuExpanded(): boolean {
        return this.isMobileSubmenuExpanded(this.recentMenuSectionName);
    }

    getSettingsMenuItem(): any {
        return (this.menu || []).find((item) => item.angularPageLink === '/settings/basic-data');
    }

    isSettingsMenuExpanded(): boolean {
        return this.isMobileSubmenuExpanded(this.settingsMenuSectionName);
    }

    isSettingsRoute(): boolean {
        return this.router.url.startsWith('/settings/');
    }

    handleSettingsMenuClick(event?: MouseEvent) {
        const settingsItem = this.getSettingsMenuItem();

        if (window.innerWidth <= 767 && settingsItem?.subMenu?.length) {
            if (event) event.preventDefault();
            const menuItemElement = (event?.currentTarget as HTMLElement)?.closest('li') as HTMLElement;
            this.toggleMobileSubmenuWithScroll(this.settingsMenuSectionName, menuItemElement);
            return;
        }

        this.handleBottomMenuClick('/settings/portal-setting', event);
    }

    toggleMobileSubmenuWithScroll(menuName: string, menuItemElement?: HTMLElement) {
        this.toggleMobileSubmenu(menuName);

        if (this.expandedMobileMenus.has(menuName)) {
            setTimeout(() => {
                this.scrollMenuItemIntoView(menuItemElement);
            }, 60);
        }
    }

    isMobileSubmenuExpanded(menuName: string): boolean {
        return this.expandedMobileMenus.has(menuName);
    }

    handleSubmenuClick(subItem: any, parentItem?: any, event?: MouseEvent) {
        // Håndter Ctrl+klikk/Cmd+klikk
        if (event && (event.ctrlKey || event.metaKey) && subItem.angularPageLink) {
            event.preventDefault();
            window.open(window.location.origin + subItem.angularPageLink, '_blank');
            return;
        }

        // Prevent default to ensure we control navigation
        if (event) event.preventDefault();

        // Navigate and close menu
        if (subItem.angularPageLink) {
            this.router.navigateByUrl(subItem.angularPageLink).then(() => {
                this.addRecentMenuItem(subItem, parentItem);
                this.closeMobileMenu();
            });
        }
    }

    handleMenuClick(item: any, event?: MouseEvent) {
        // Håndter Ctrl+klikk/Cmd+klikk først
        if (event && (event.ctrlKey || event.metaKey) && item.angularPageLink) {
            event.preventDefault();
            window.open(window.location.origin + item.angularPageLink, '_blank');
            return;
        }

        // På mobil (<=767px) med submeny: toggle submeny (ikke lukk menyen)
        if (item.subMenu ?.length && window.innerWidth <= 767) {
            if (event) event.preventDefault();
            const menuItemElement = (event?.currentTarget as HTMLElement)?.closest('li') as HTMLElement;
            this.toggleMobileSubmenuWithScroll(item.name, menuItemElement);
            return; // Don't navigate, just toggle submenu
        }

        // Uten submeny på mobil: naviger og lukk menyen
        if (window.innerWidth <= 767 && !item.subMenu ?.length) {
            if (event) event.preventDefault();
            this.router.navigateByUrl(item.angularPageLink).then(() => {
                this.addRecentMenuItem(item, item);
                this.closeMobileMenu();
            });
            return;
        }

        // Desktop: normal navigasjon
        if (event) event.preventDefault();
        this.navigateByUrl(item.angularPageLink, event);
    }

    /**
     * Handle bottom menu clicks (Logg ut, Min profil, Innstillinger)
     * Navigates and closes mobile menu
     */
    handleBottomMenuClick(url: string, event?: MouseEvent) {
        // Handle Ctrl+Click for new tab
        if (event && (event.ctrlKey || event.metaKey)) {
            event.preventDefault();
            window.open(window.location.origin + url, '_blank');
            return;
        }

        if (event) event.preventDefault();

        // On mobile: navigate then close menu
        if (window.innerWidth <= 767) {
            this.router.navigateByUrl(url).then(() => {
                this.closeMobileMenu();
            });
        } else {
            // Desktop: normal navigation
            this.navigateByUrl(url, event);
        }
    }

    scrollIntoView() {
        var element = document.querySelector('app-root');
        element.scrollIntoView();
    }

    adminPage(routerLink) {
        if (routerLink == '/settings/system-setting') {
            try {
                const userAccess: any[] = this.user?.userAccess || [];
                return userAccess.some((a: any) => a.moduleID === 99 && (a.new === true || a.new === 1));
            } catch {
                return false;
            }
        }
        return true;
    }

    shouldShowMenuItem(item: any): boolean {
        // For Fixed Asset menu, check if it was included in the menu from backend
        // If backend included it, user has rights. If not, it shouldn't be shown.
        // Since backend already filters by rights, we can just show all items in this.menu
        return true;
    }

    isActive2(url): boolean {
        var value = this.router.url.split('?');
        if (value[0] == url) return true;
        return false;
    }

    isSettingsItem(item: any): boolean {
        const name = (item.name || '').toLowerCase();
        return name.startsWith('innstilling') || name.startsWith('setting');
    }

    getCurrentMenuTitle(): string {
        if (this.currentMenu?.name) {
            return this.currentMenu.name;
        }

        if (this.isExternalUser) {
            return this.translateService.instant('Menu.ePortal');
        }

        return '';
    }

    showError(error) {
        this.toastService.show({
            type: 'error',
            data: error,
        });
    }

    setFixedAssetMenu(value) {
        localStorage.setItem(AppSettings.StorageKeys.IsFixedAssetMenu, value);
        this.isFixedAssetMenu = value;
        this.applyMobileMenuFilters();
        if (this.isFixedAssetMenu == false) {
            this.router.navigateByUrl('/home');
            this.scrollIntoView();
        }
    }

    isActive(url?: string): boolean {
        if (!url) {
            return false;
        }
        if (url.startsWith('http')) {
            return false;
        }
        return this.router.isActive(url, {
            paths: 'exact',
            queryParams: 'ignored',
            fragment: 'ignored',
            matrixParams: 'ignored',
        });
    }

    hasActiveChild(item: any): boolean {
        return item.subMenu?.some((child: any) => this.isActive(child.angularPageLink)) || false;
    }
}
